<template>
  <table class="table is-fullwidth">
    <thead>
      <tr>
        <th>Years</th>
        <th class="has-text-right">Energy (kWh)</th>
        <th class="has-text-right">Cars Per Year</th>
        <th class="has-text-right">Metric Tonnes of CO2</th>
        <th class="has-text-right">Electricity of Homes Per Year</th>
        <th class="has-text-right">Trees Planted</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td class="has-text-right">
          {{ totEnergy | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.cars_per_year_ratio | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.metric_tones_co2_ratio | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.elec_homes_ratio | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.no_of_trees_ratio | commasep(0) }}
        </td>
      </tr>
      <tr>
        <td>30</td>
        <td class="has-text-right">
          {{ totEnergy * 30 | commasep(0)}}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.cars_per_year_ratio * 30 | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.metric_tones_co2_ratio * 30 | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.elec_homes_ratio * 30 | commasep(0) }}
        </td>
        <td class="has-text-right">
          {{ totEnergy / 1000 * estimation.no_of_trees_ratio * 30 | commasep(0) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    estimation: {
      type: Object,
      required: true
    },
    estimationSummary: {
      type: Object,
      required: true
    },
    sunHourFields: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      elevationMap: {
        'North': 'sunlight_n', 
        'South': 'sunlight_s',
        'East': 'sunlight_e',
        'West': 'sunlight_w',
        'N/ East': 'sunlight_ne',
        'N/ West': 'sunlight_nw', 
        'S/ East': 'sunlight_se', 
        'S/ West': 'sunlight_sw'
      }
    }
  },
  computed: {
    totEnergy({ estimation, estimationSummary, elevationMap, sunHourFields }) {
      return estimationSummary.by_elevation.map(
        d => {
          if (d.elevation == 'Whole Building') {
            let avg = sunHourFields.map(
              elevation => estimation[elevation]
            ).reduce((a,b) => a + +b, 0) / sunHourFields.length

            return avg * d.system_capacity
          } else {
            return d.system_capacity * estimation[elevationMap[d.elevation]]
          }
        }
      ).reduce((a,b) => a + +b, 0)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
</style>